import React from "react";
import { Tooltip } from "@mui/material";
import { GENERATION_STATUS, GENERATION_STATUS_LOOKUP, JOB_STATUS_LOOKUP, JOB_STATUS_MAP, SUBMISSION_STATUS, SUBMISSION_STATUS_LOOKUP } from "../../constants/Statuses";
import { Cached, CalendarMonthOutlined, CallReceivedOutlined, CancelOutlined, Check, CheckCircle, FeedbackOutlined, HourglassEmpty, InfoOutlined, PublicRounded, ScheduleOutlined, ThumbUpOutlined } from "@mui/icons-material";
import Colors from "../../constants/Colors";

const StyledStatusIcon = ({
  status = '',
  sx,
  ...props
}) => {
    const { label, description } = JOB_STATUS_LOOKUP[status.toUpperCase()] || SUBMISSION_STATUS_LOOKUP[status.toUpperCase()] || GENERATION_STATUS_LOOKUP[status.toUpperCase()] || {}
    const style = { cursor: 'pointer', fontSize: '28px' };
    
    const ICONS = {
        [JOB_STATUS_MAP.APPROVED]: <ThumbUpOutlined style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [JOB_STATUS_MAP.IN_PROGRESS]: <Cached style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [JOB_STATUS_MAP.PENDING_APPROVAL]: <ThumbUpOutlined style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,
        [JOB_STATUS_MAP.REQUESTED_CLIENT_FEEDBACK]: <HourglassEmpty style={{ ...style, color: Colors.warningBackground, ...sx }} {...props} />,
        [JOB_STATUS_MAP.REQUESTED_CLIENT_ITEMS]: <FeedbackOutlined style={{ ...style, color: Colors.warningBackground, ...sx }} {...props} />,
        [JOB_STATUS_MAP.QUEUED]: <ScheduleOutlined style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [JOB_STATUS_MAP.COMPLETED]: <CheckCircle style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,

        [SUBMISSION_STATUS.SUBMITTED]: <CallReceivedOutlined style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,
        [SUBMISSION_STATUS.IN_PROGRESS]: <Cached style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [SUBMISSION_STATUS.AWAITING_DETAILS]: <HourglassEmpty style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,
        [SUBMISSION_STATUS.COMPLETED]: <CheckCircle style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [SUBMISSION_STATUS.CANCELED]: <CancelOutlined style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,

        [GENERATION_STATUS.SUCCESS]: <CheckCircle style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
        [GENERATION_STATUS.FAILURE]: <CancelOutlined style={{ ...style, color: Colors.redColor, ...sx }} {...props} />,
        [GENERATION_STATUS.SUBMITTED]: <ThumbUpOutlined style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,
        [GENERATION_STATUS.PENDING]: <Cached style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />,
        [GENERATION_STATUS.PUBLISHED]: <PublicRounded style={{ ...style, color: Colors.primaryColor, ...sx }} {...props} />,
    }

    const icon = ICONS[status.toUpperCase()] || <InfoOutlined style={{ ...style, color: Colors.blueColor, ...sx }} {...props} />;

    return (<Tooltip title={`${label}: ${description}`}>{icon}</Tooltip>)
}

export default StyledStatusIcon;
